import React, { useState } from 'react';
import { ArrowRight, Check, Sparkles, Mic, BarChart3, Zap, Lock, Crown } from 'lucide-react';

const AppSumoPage = () => {
  const [code, setCode] = useState('');

  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      {/* Nav */}
      <nav className="px-6 py-4">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/stilos-logo.png" alt="Stilos" className="w-8 h-8 rounded-lg object-cover" />
            <span className="font-display font-semibold text-base tracking-tight">Stilos</span>
          </div>
          <a href="/" className="btn btn-secondary text-sm">Go to app</a>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-16 pb-20 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="font-label text-[var(--color-coral)] mb-4 inline-block">APPSUMO LIFETIME DEAL</span>
          <h1 className="headline-hero mb-6">
            <span className="accent">Lifetime</span> access<br />to AI content creation
          </h1>
          <p className="text-base text-[var(--color-muted)] max-w-xl mx-auto mb-10 leading-relaxed">
            One payment. Unlimited articles. Build content pillars that make AI cite <em>you</em>.
          </p>

          <div className="inline-block p-8 rounded-[20px] text-left bg-white" style={{boxShadow: 'inset 0 0 0 2px var(--color-coral)'}}>
            <div className="text-center mb-6">
              <div className="font-label text-[var(--color-coral)] mb-2">LIFETIME DEAL</div>
              <div className="flex items-end justify-center gap-1 mb-1">
                <span className="font-display text-4xl font-light line-through text-[var(--color-muted)]">&#8364;948</span>
                <span className="font-display text-5xl font-light text-[var(--color-charcoal)]">&#8364;79</span>
              </div>
              <p className="text-xs text-[var(--color-muted)]">one-time payment &middot; lifetime access</p>
            </div>
            <div className="space-y-2.5 mb-6">
              {[
                '200 articles/month', '2,000 credits/month', 'Voice AI', 'AI Assistant',
                'All publishing integrations', 'Priority support', 'All future updates'
              ].map((f, i) => (
                <div key={i} className="flex items-center gap-2.5 text-sm">
                  <Check className="w-4 h-4 text-[var(--color-coral)]" />
                  <span>{f}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              <input type="text" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
                className="input flex-1 font-mono text-sm" placeholder="APPSUMO CODE" data-testid="appsumo-code-input" />
              <button className="btn btn-accent" data-testid="appsumo-redeem-btn">
                Redeem <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* What you get */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <span className="font-label text-[var(--color-coral)] mb-3 inline-block">FEATURES</span>
            <h2 className="font-serif text-3xl">Everything you need</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            {[
              { icon: Sparkles, title: 'AI Article Generation', desc: 'Full articles from a title. SEO-optimized. Ready to publish.' },
              { icon: Mic, title: 'Voice to Article', desc: 'Speak for 2 minutes, get a complete blog post.' },
              { icon: BarChart3, title: 'SEO Scoring', desc: 'Real-time scoring and improvement suggestions.' },
              { icon: Zap, title: 'Direct Publishing', desc: 'Push directly to WordPress, Medium, LinkedIn.' },
            ].map((f, i) => (
              <div key={i} className="card card-hover p-7">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 bg-[var(--color-surface)]">
                  <f.icon className="w-5 h-5 text-[var(--color-coral)]" />
                </div>
                <h3 className="font-display text-sm font-medium mb-1">{f.title}</h3>
                <p className="text-xs text-[var(--color-muted)] leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-serif text-3xl mb-4">Limited time offer</h2>
          <p className="text-[var(--color-muted)] text-sm mb-8">
            This lifetime deal won't last forever. Get in before it's gone.
          </p>
          <a href="#" className="btn btn-accent text-base px-8 py-3">
            Get the deal <Crown className="w-5 h-5" />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 px-6 border-t border-[var(--color-border)]">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/stilos-logo.png" alt="Stilos" className="w-6 h-6 rounded-md object-cover" />
            <span className="text-xs text-[var(--color-muted)]">Stilos &middot; Part of Themelio</span>
          </div>
          <p className="text-xs text-[var(--color-muted)]">&copy; 2026 Stilos</p>
        </div>
      </footer>
    </div>
  );
};

export default AppSumoPage;
